import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Grid } from '@mui/material';

const SortableListTile = ({ 
  list, 
  children, 
  onMouseEnter, 
  onMouseLeave,
  isHovered,
  tileHeight 
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: list.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: isDragging ? transition : 'height 0.3s ease-in-out, transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    opacity: isDragging ? 0.8 : 1,
    zIndex: isDragging ? 999 : 'auto',
    position: 'relative',
    cursor: isDragging ? 'grabbing' : 'grab',
    touchAction: 'manipulation', // Better touch support
    filter: isDragging ? 'brightness(1.1) drop-shadow(0 8px 16px rgba(0,0,0,0.15))' : 'none',
    overflow: 'visible', // Allow selection indicator to extend outside tile
  };

  // Handle mouse events - only call parent handlers if not dragging
  const handleMouseEnter = (e) => {
    if (!isDragging && onMouseEnter) {
      onMouseEnter(e);
    }
  };

  const handleMouseLeave = (e) => {
    if (!isDragging && onMouseLeave) {
      onMouseLeave(e);
    }
  };

  return (
    <Grid 
      item 
      xs={12} 
      sm={6} 
      md={4} 
      lg={4} 
      xl={3}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </Grid>
  );
};

export default SortableListTile;